var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.showTitle)?_c('div',{staticClass:"block-title"},[_c(_vm.moduleIndex === 0 ? 'h1' : 'h2',{tag:"component",staticClass:"block-title__text"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }